module.exports = __webpack_public_path__ + "assets/media/client_training.307bd3c8.mp3";